import tracking from '../../utils/tracking';

type State = {
  step: number,
  score: number,
  currentTreePosition?: {
    expanded: false,
    selected: [],
    cardType?: any,
  },
  answers?: {}
}

class ConditionalQuiz {
  domRoot: HTMLElement;
  mainRoot: any;
  scoreRoot: any;
  params: any;
  labels: any;
  firstChoice: string;
  currentState: State;
  previousState: State;
  scores: any;
  questions: any;
  cardContainer: any;
  uniqueAnswers: any[];
  stepsHistory: any[];

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.mainRoot = this.domRoot.querySelector('.parent-quiz');
    this.scoreRoot = this.domRoot.querySelector('.scores-area');
    this.params = params;
    this.labels = params.labels;
    this.firstChoice = Object.keys(params.choices)[0];
    this.currentState = {
      step: 0,
      score: 0
    };
    this.previousState = {
      step: 0,
      score: 0
    };
    this.scores = params.scores;
    this.questions = params.questions;
    this.cardContainer;
    this.uniqueAnswers = [];
    this.stepsHistory = [];
    this.init();
  }

  init() {
    this.scoreRoot.addEventListener('click', (e) => {
      tracking.trackLateRenderedEvent("clicked", e.target);
    });
    this.checkQuizAndAdvance(true);
  }

  checkQuizAndAdvance(startFromZero, startOver) {
    this.previousState = JSON.parse(JSON.stringify(this.currentState));
    if (startFromZero) {
      this.currentState = {
        step: -1,
        score: 0,
        currentTreePosition: {
          expanded: false,
          selected: []
        },
        answers: {}
      };
    }
    let clicked = this.currentState.currentTreePosition?.selected;
    let cardType = this.currentState.currentTreePosition?.cardType;
    let shouldShowErrors = cardType == "radio" && clicked.length == 0;

    if (shouldShowErrors && this.currentState.step > 0) {
      this.renderQuiz(true);
    } else {
      const choiceSelected = clicked[0];
      const choiceVal = this.domRoot.querySelector('#' + choiceSelected) ? Number(this.domRoot.querySelector('#' + choiceSelected).value) : 0;
      const choiceSlug = clicked.length > 0 ? clicked : this.firstChoice;
      if (this.currentState.step > 0 && this.domRoot.querySelector('#' + choiceSelected)) {
        clicked.forEach((ans, index) => {
          this.currentState.answers[this.currentState.step + '-choice-' + index] = {
            question: document.querySelector('.card-question-title').innerText,
            answer: this.domRoot.querySelector('#' + ans).innerText,
            openEndedAnswer: this.domRoot.querySelector("#" + ans + '-open') ? this.domRoot.querySelector("#" + ans + '-open').value : undefined
          }
        })
      }

      let thisUnique = [];
      clicked.forEach(click => {
        thisUnique.push(this.currentState.currentTreePosition.choices[click].choiceSlug);
      })
      this.uniqueAnswers.push(thisUnique);
      this.currentState.step += 1;
      if (startOver) {
        this.uniqueAnswers = [];
        this.previousState.step = 1;
      }
      this.currentState.score += choiceVal;
      var newPosition;

      if (this.currentState.step < 2) {
        newPosition = JSON.parse(JSON.stringify(this.params.choices[this.firstChoice]));
      } else if (this.currentState.currentTreePosition.card) {
        newPosition = this.currentState.currentTreePosition.card;
      } else if (this.currentState.currentTreePosition.choices[choiceSlug[0]] && this.currentState.currentTreePosition.choices[choiceSlug[0]].card) {
        newPosition = this.currentState.currentTreePosition.choices[choiceSlug[0]].card;
      }
      if (newPosition) {
        newPosition.selected = [];
      }

      this.stepsHistory.push(this.previousState);

      this.currentState.currentTreePosition = newPosition;
      this.renderQuiz();

      if (!startFromZero) {
        window.scrollTo({
          left: 0,
          top: this.domRoot.offsetTop,
          behavior: 'smooth'
        });
      }
    }
  }

  renderQuiz(withErrors?: boolean) {
    const prevStep = this.previousState.step;
    const thisStep = this.currentState.step;
    let animateClass = thisStep < prevStep ? " adding" : " subtracting";
    let tossedCard = this.mainRoot.lastElementChild;

    if (thisStep < prevStep || withErrors || thisStep == 0) {
      // no need to animate if re-checking or if starting from zero
    } else {
      tossedCard.className += " tossdown";
      this.mainRoot.removeChild(tossedCard);
      this.domRoot.appendChild(tossedCard);
      setTimeout(() => {
        this.domRoot.removeChild(tossedCard);
      }, 500);
    }
    this.scoreRoot.innerHTML = "";
    this.mainRoot.className = "parent-quiz" + (withErrors || thisStep == prevStep ? "" : animateClass);
    this.mainRoot.innerHTML = this.topper();
    const cardContainer = this.el("div", {
      className: "card narrow"
    });
    this.mainRoot.appendChild(cardContainer);

    if (thisStep > 1 && this.currentState.currentTreePosition == undefined) {
      this.renderLastCard();
    } else if (thisStep > 0) {
      this.renderQuestionCard(withErrors);
    } else {
      this.renderFirstCard();
    }
  }

  renderQuestionCard(withErrors?: boolean) {
    const cardContainer = this.mainRoot.lastElementChild;
    let totalCards = this.params.choices[this.firstChoice].totalCards;

    let cardPosition = this.currentState.currentTreePosition;
    let currentStep = cardPosition.customStep ? cardPosition.customStep : this.currentState.step;
    cardContainer.innerHTML += `
    <h5 class="eyebrows">
      <span class="current-step">${currentStep}</span>
      ${totalCards > 0 ? `<span class="remaining">/ ${totalCards}</span>` : ``}
    </h5>
    <h3 class="card-question-title">${cardPosition.title}</h3>`;

    if (cardPosition.expandCollapseLabel) {
      cardContainer.appendChild(this.el("button", {
        className: `expander ${cardPosition.expanded ? 'toggled' : ''}`,
        innerHTML: cardPosition.expandCollapseLabel,
        onclick: () => {
          tracking.trackEvent("clicked", {
            label: cardPosition.expandCollapseLabel,
            expanding: !cardPosition.expanded,
            event: "clicked",
            eventComponent: "linkButton"
          });
          cardPosition.expanded = !cardPosition.expanded;
          this.renderQuiz(true);
        }
      }));
    }
    cardContainer.appendChild(this.el("div", {
      className: `extra-content ${cardPosition.expandCollapse ? 'expandable' : ''} ${cardPosition.expanded ? 'expanded' : ''}`,
      innerHTML: cardPosition.extraContent,
      onclick: (e) => {
        tracking.trackLateRenderedEvent("clicked", e.target);
      }
    }));
    for (let option in cardPosition.choices) {
      let cardChoice = cardPosition.choices[option];
      cardContainer.appendChild(this.el("button", {
        className: `card-choice wide-button ${cardPosition.cardType}` + (cardPosition.selected.includes(option) ? " checked" : " unchecked"),
        value: cardChoice.value,
        id: option,
        innerHTML: cardChoice.title,
        onclick: (e) => {
          let newArray = cardPosition.selected;
          if (e.target.classList.contains("radio")) {
            newArray = [e.target.id];
          } else if (e.target.classList.contains("checkbox")) {
            if (!e.target.classList.contains("checked")) {
              newArray.push(e.target.id)
            } else if (e.target.classList.contains("checked") && newArray.includes(e.target.id)) {
              let newIndex = newArray.indexOf(e.target.id);
              newArray.splice(newIndex, 1);
            }
          }
          tracking.trackEvent("clickQuizChoice", {
            label: cardPosition.choices[option].title,
            event: "clicked",
            eventComponent: "linkButton"
          });
          cardPosition.selected = newArray;
          this.renderQuiz(true);
        }
      }));

      if (cardChoice.openEnded && cardPosition.selected.includes(option)) {
        let textInput = this.el("input", {
          className: "open-ended" + (cardPosition.selected.includes(option) ? " shown" : " hidden"),
          type: "text",
          id: option + "-open",
          placeholder: cardChoice.openEndedPlaceholder ? cardChoice.openEndedPlaceholder : "",
          value: cardChoice.openValue ? cardChoice.openValue : "",
          onkeyup: (e) => {
            cardChoice.openValue = e.target.value;
          }
        });
        cardContainer.appendChild(textInput);
      }
    }

    var shouldShowErrors = cardPosition.cardType == "radio" && this.currentState.currentTreePosition.selected.length == 0;
    cardContainer.appendChild(this.el("div", {
      className: "error grow-box",
      innerHTML: withErrors && shouldShowErrors ? this.labels.error : ""
    }));
    const buttonContainer = this.el("div", {
      className: "buttons"
    });
    buttonContainer.appendChild(this.el("button", {
      innerHTML: this.labels.back,
      className: "button--secondary button--small",
      onclick: () => {
        this.uniqueAnswers.pop();
        tracking.trackEvent('goBack', {
          label: this.labels.back,
          event: "clicked",
          eventComponent: "linkButton",
          parentLabel: cardPosition.title
        });
        this.currentState = this.stepsHistory.pop();
        this.renderQuiz();
      }
    }));
    buttonContainer.appendChild(this.el("button", {
      innerHTML: this.labels.next,
      className: "button--orange button--small right",
      onclick: () => {
        tracking.trackEvent('clickQuizForward', {
          label: this.labels.next,
          event: "clicked",
          eventComponent: "linkButton",
          parentLabel: cardPosition.title
        });
        this.checkQuizAndAdvance();
      }
    }));
    cardContainer.appendChild(buttonContainer)
  }

  renderFirstCard() {
    const cardContainer = this.mainRoot.lastElementChild;
    const selectOptions = this.el("select", {
      className: "wide-button"
    });
    selectOptions.addEventListener('change', (e) => this.firstChoice = e.target.value);

    for (var firstChoice in this.params.choices) {
      selectOptions.innerHTML += `<option value="${firstChoice}" ${firstChoice == this.firstChoice ? "selected" : ""}>
        ${this.params.choices[firstChoice].firstChoiceTitle}
      </option>`;
    }

    const startButton = this.el("button", {
      innerHTML: this.labels.start,
      className: "wide-button button--orange"
    });
    startButton.addEventListener('click', () => {
      this.checkQuizAndAdvance();
      tracking.trackEvent('startQuiz', {
        label: this.labels.start,
        event: "clicked",
        eventComponent: "linkButton",
      });
    });
    cardContainer.innerHTML = this.params.firstCard;

    this.questions.forEach(question => {
      cardContainer.appendChild(this.el("label", {
        innerHTML: question.title
      }));

      if (question.questionType == "select") {
        let selector = this.el("select", {
          value: question.answer,
          onchange: (e) => {
            question.answer = e.target.value;
          }
        });
        question.options.forEach(option => {
          selector.appendChild(this.el("option", {
            value: option,
            innerText: option
          }))
        })
        cardContainer.appendChild(selector);
      } else {
        cardContainer.appendChild(this.el("input", {
          type: "text",
          value: question.answer,
          onkeyup: (e) => {
            question.answer = e.target.value;
          }
        }));
      }

    });

    cardContainer.appendChild(this.el("label", {
      innerHTML: this.labels.firstQuestion
    }));
    cardContainer.appendChild(selectOptions);
    cardContainer.appendChild(startButton);
  }

  renderLastCard() {
    tracking.trackEvent('Completed Quiz', {
      event: "clicked",
      eventComponent: "linkButton",
      questions: this.questions,
      score: this.currentState.score,
      productChosen: this.firstChoice,
      quizQuestionsAndAnswers: this.currentState.answers
    });

    const cardContainer = this.mainRoot.lastElementChild;
    cardContainer.innerHTML += this.params.lastCard;
    const lastButton = this.el("button", {
      innerHTML: this.labels.startOver,
      className: "button--small button--outline"
    });
    lastButton.addEventListener('click', () => {
      this.checkQuizAndAdvance(true, true);
      tracking.trackEvent("clicked", {
        event: "clicked",
        eventComponent: "linkButton",
        label: this.labels.startOver
      });
    });
    cardContainer.appendChild(lastButton);
    cardContainer.appendChild(this.el("div", {
      className: "grow-box"
    }));
    const finalScore = this.currentState.score;
    const indScores = this.params.choices[this.firstChoice].scores.length ? this.params.choices[this.firstChoice].scores : this.scores;
    for (let score in indScores) {
      let indScore = indScores[score];
      let isMatchingScore = finalScore >= indScore.minVal && finalScore < indScore.maxVal;
      let scoreContainer = this.el("div", {
        className: `score-container  ${isMatchingScore ? " visible-score" : "hidden-score"}`
      });
      let scoreHeader = this.el("button", {
        className: `${indScore.bgColor} wide-button header ${indScore.textColor}`,
        innerHTML: (isMatchingScore ? "" : "<span>+</span>") + indScore.title,
        onclick: function (e) {
          const contentNode = e.target.nextElementSibling;
          contentNode.style.display = contentNode.style.display == "block" && contentNode.className == "content hidden" ? "none" : "block";
          const plusIndicator = e.target.children[0];
          if (plusIndicator) {
            plusIndicator.innerHTML = plusIndicator.innerHTML === "+" ? "-" : "+";
          }
          tracking.trackEvent("clicked", {
            event: "clicked",
            eventComponent: "linkButton",
            label: indScore.title,
          });
        }
      });
      scoreContainer.appendChild(scoreHeader);
      scoreContainer.appendChild(this.el("div", {
        className: "content " + (isMatchingScore ? "" : "hidden"),
        innerHTML: indScore.content
      }));
      if (isMatchingScore) {
        this.scoreRoot.insertBefore(scoreContainer, this.scoreRoot.firstChild);
      } else {
        this.scoreRoot.appendChild(scoreContainer);
      }
    }
    this.smoothScroll(this.scoreRoot);

    /* show results for unique questions answered */
    this.uniqueAnswers.flat().forEach(question => {

      let correspondingElements = this.domRoot.querySelectorAll('.' + question);
      if (correspondingElements.length) {
        correspondingElements.forEach(elem => {
          elem.classList.remove('hide-all')
        });
      }
    });
  }

  el(type: string, parameters: { [name: string]: string }) {
    const newEl = document.createElement(type) as HTMLElement;
    for (let parameter in parameters) {
      // @ts-ignore
      newEl[parameter] = parameters[parameter];
    }
    return newEl;
  }

  topper() {
    return `<div class="toppers">
      <div class="topper last"></div>
      <div class="topper mid"></div>
      <div class="topper front"></div>
    </div>`;
  }

  smoothScroll(item: any) {
    let initialScroll = window.scrollY;
    let itemPosition = this.offsetTopFind(item);
    let increment = (initialScroll - itemPosition) * 0.02;
    let delay = 1000 / increment;
    let scrollInterval = setInterval(winScroll, delay);

    function winScroll() {
      if (Math.abs(initialScroll - itemPosition) > 100) {
        initialScroll = initialScroll - increment;
        window.scrollTo(0, initialScroll);
      } else {
        clearInterval(scrollInterval);
        window.scrollTo(0, itemPosition);
      }
    }
  }

  offsetTopFind(el, withHeight = 0) {
    var yPosition = withHeight;
    while (el.parentNode !== null) {
      yPosition += el.offsetTop;
      el = el.parentNode;
    }
    return yPosition;
  }
}

export default ConditionalQuiz;